<template>
	<aside class="app-sidebar" :class="{ open: sidebarOpen, close: sidebarClose }">
		<router-link to="/" @click="closeSidebar">
			<img src="@/assets/logo.svg" alt="CIL Logo" class="logo" />
		</router-link>
		<div class="content">
			<div class="main-category">
				<ul class="sidebar-menu">
					<li>
						<router-link to="/" @click="closeSidebar"> <i class="bi bi-house-fill"></i>Mon logement
						</router-link>
					</li>
				</ul>
			</div>
			<hr />
			<div class="sub-category">
				<ul class="sidebar-menu one">
					<li>
						<router-link to="/mes-travaux" @click="closeSidebar"> <i
								class="bi bi-wrench-adjustable"></i>Travaux </router-link>
					</li>
					<li>
						<router-link to="/mes-equipements" @click="closeSidebar"> <i class="bi bi-tools"></i>Équipements
						</router-link>
					</li>
					<li>
						<router-link to="/mes-partages" @click="closeSidebar"> <i class="bi bi-share-fill"></i>Partages
						</router-link>
					</li>
				</ul>
				<div v-if="showAlert" class="free-alert">
					<div class="alert-title">{{ alertTitle }}</div>
					<div class="alert-text">Veuillez ajouter un moyen de paiement pour continuer l'abonnement.</div>
					<span class="u cta" @click="addPaymentMethod">Cliquez ici</span>
				</div>
				<ul class="sidebar-menu two">
					<li>
						<router-link to="/mes-logements"> <i class="bi bi-gear-fill"></i>Mes CILs </router-link>
					</li>
					<li style="margin-bottom: 0">
						<router-link to="/profil/abonnements">
							<i class="bi bi-credit-card-2-back-fill"></i>Abonnements</router-link>
					</li>
				</ul>
			</div>
		</div>
	</aside>
	<button class="hamburger" :class="{ close: sidebarClose }" :style="{ top: showAlert ? '42px' : '20px' }"
		@click="toggleSidebar">
		<i class="bi bi-list"></i>
	</button>
	<div class="overlay" v-if="sidebarOpen" @click="closeSidebar"></div>
	<AjouterPaiement :isVisible="showPaymentPopup" :subID="this.subscriptionID" @confirm="closePaymentPopup"
		@cancel1="closePaymentPopup">
	</AjouterPaiement>
</template>

<script>
import AjouterPaiement from "@/components/AjouterPaiement.vue";

export default {
	name: "SideBar",
	components: {
		AjouterPaiement
	},
	data() {
		return {
			sidebarOpen: false,
			sidebarClose: false,
			showAlert: false,
			alertTitle: '',
			subscriptionID: ''
		};
	},
	methods: {
		toggleSidebar() {
			this.sidebarOpen = !this.sidebarOpen;
		},
		closeSidebar() {
			this.sidebarOpen = false;
		},
		async addPaymentMethod() {
			this.subscriptionID = 123;
			this.showPaymentPopup = true;
		},
		closePaymentPopup() {
			this.fetchSubscriptionStatus();
			this.showPaymentPopup = false;
		},
		async fetchSubscriptionStatus() {
			try {
				let currentProperty = JSON.parse(localStorage.getItem('currentProperty'));

				if (!currentProperty) {
					const checkPropertyInterval = setInterval(async () => {
						currentProperty = JSON.parse(localStorage.getItem('currentProperty'));

						if (currentProperty) {
							clearInterval(checkPropertyInterval);
							await this.fetchSubscriptionStatus();
						}
					}, 1000);
					return;
				}

				if (currentProperty && currentProperty.stripe_ID) {
					const stripe_ID = currentProperty.stripe_ID;

					const response = await fetch(process.env.VUE_APP_API_URL + 'user/subscription', {
						method: 'POST',
						credentials: "include",
						headers: { 'Content-Type': 'application/json', },
						body: JSON.stringify({ subID: stripe_ID }),
					});

					if (!response.ok) throw new Error('Erreur lors de la récupération de la souscription.');

					const data = await response.json();

					this.subscriptionID = data.id;
					if (data.status === 'trialing' && data.paymentMethodDetails === false) {
						const currentTime = Math.floor(Date.now() / 1000);
						const timeRemaining = data.trial_end - currentTime;
						const daysRemaining = Math.floor(timeRemaining / 86400);

						this.alertTitle = `Version d'essai J-${daysRemaining}`;
						this.showAlert = true;
					} else {
						this.showAlert = false;
					}
				} else {
					console.error('Aucune propriété sélectionnée ou stripe_ID manquant.');
				}
			} catch (error) {
				console.error('Erreur:', error);
			}
		},
		setActiveClass() {
			const currentRoute = this.$route.path;
			this.$nextTick(() => {
				const sidebarLinks = document.querySelectorAll(".sidebar-menu li");

				sidebarLinks.forEach((link) => {
					const href = link.querySelector("a").getAttribute("href");
					if (currentRoute === href) {
						link.classList.add("active");
					} else {
						link.classList.remove("active");
					}
				});
			});
		},
	},
	watch: {
		$route() {
			this.setActiveClass();
			if (this.$route.path.includes('/mes-logements')) this.sidebarClose = true;
			else this.sidebarClose = false;
		},
	},
	mounted() {
		this.setActiveClass();
		this.fetchSubscriptionStatus();
		if (this.$route.path.includes('/mes-logements')) this.sidebarClose = true;
		else this.sidebarClose = false;
	},
};
</script>

<style scoped>
.app-sidebar {
	width: 300px;
	min-width: 300px;
	padding: 50px;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	background-color: #fff;
	position: sticky;
	top: 0;
	height: 100dvh;
	transition: transform 0.3s ease;
}

.app-sidebar.open {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	z-index: 1000;
	box-shadow: 2px 0 5px rgba(0, 0, 0, 0.5);
}

.app-sidebar.close {
	display: none;
}

.app-sidebar .content {
	display: flex;
	flex: 1;
	flex-direction: column;
}

.hamburger {
	display: none;
	position: absolute;
	top: 20px;
	left: 10px;
	background: none;
	border: none;
	font-size: 24px;
	z-index: 1001;
	cursor: pointer;
	color: #359590;
}

.hamburger.close {
	display: none;
}

.overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	z-index: 999;
}

@media (max-width: 950px) {
	.app-sidebar {
		display: none;
	}

	.app-sidebar.open {
		display: flex;
	}

	.hamburger {
		display: block;
	}
}

hr {
	width: 100%;
	margin: 10px 0 20px;
}

.logo {
	margin-bottom: 50px;
}

.sidebar-menu {
	list-style-type: none;
	padding: 0;
	margin: 0;
}

.sidebar-menu li {
	margin-bottom: 20px;
	position: relative;
}

.sidebar-menu li.active a {
	color: #359390;
}

.sidebar-menu li.active::before {
	content: "";
	position: absolute;
	top: 0;
	right: -50px;
	height: 100%;
	width: 3px;
	background-color: #359390;
}

.sidebar-menu li a {
	text-decoration: none;
	color: #000;
	display: flex;
	align-items: center;
	gap: 15px;
	transition: color 0.3s ease;
}

.sidebar-menu li a:hover {
	color: #359390;
}

.main-category a {
	font-size: 22px;
	font-weight: bold;
}

.sub-category {
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	position: relative;
}

.sub-category a {
	font-size: 20px;
}
</style>
